import { useState, useEffect } from 'react'

import { Card, InputLabel } from '@scuf/common'
import { DataTable } from '@scuf/datatable';
import { useDispatch } from 'react-redux'
import DataTabData from './DatTabData'
import DataTabDataAPI from './DatTabDataAPI'
import baseServices from '../../../services/base.services';
//import { startLineChart } from '../../../actions/entryDataChart'
import '@scuf/datatable/honeywell-compact-dark/theme.css'
import { Fragment } from 'react';
import { color } from 'highcharts';


const DatTab = ({ url, body, isCard, titleCard }) => {


    const dispatch = useDispatch();
    const [state, setState] = useState([])

    useEffect(() => {


        const getData = async () => {
            try {
                if (body) {
                    var response = await baseServices.getDataN2(body, url);
                    if (response.data && response.data.length > 0) {
                        setState(DataTabDataAPI(response))
                        setTimeout(() => {
                            getData()
                        }, 150000);

                    }
                } else {
                    setState(DataTabData())
                    setTimeout(() => {
                        getData()
                    }, 150000);
                }

            } catch (err) {
                setTimeout(() => {
                    getData()
                }, 15000);
            }
        }

        getData()

    }, [])


    return (
        <>
            {
                isCard === '1' ?

                    <Card >
                        <Card.Header title={titleCard} className='m-0 p-0'></Card.Header>
                        <Card.Content style={{ minHeight: '100px' }} className='m-0 p-0'>

                        </Card.Content>
                    </Card>
                    :
                    <Fragment>
                        <InputLabel label={titleCard} style={{ Color: 'red' }} />
                        <DataTable data={state.datos} scrollable={true} scrollHeight="300%"
                            reorderableColumns={true} resizableColumns={true}>

                            <DataTable.Column initialWidth='0.1%' />
                            {
                                state.fields && state.fields.map((y, i) => (
                                    <DataTable.Column field={y.field} header={y.field} sortable={true} />
                                ))

                            }

                            {/* <DataTable.Column field="plane" header="plane" sortable={true} />
                        <DataTable.Column field="pilot" header="pilot" sortable={true} />
                        <DataTable.Column field="status" header="status" sortable={true} />
                        <DataTable.Column field="flights" header="flights" sortable={true} /> */}

                        </DataTable>
                    </Fragment>
            }

        </>


    )
}

export default DatTab
